// Header Navigation
export const HEADER_LABELS = {
  HOME: "Home",
  SERVICES: "Services Portal",
  ANNOUNCEMENTS: "Announcements",
  ABOUT: "About",
  CONTACT: "Contact",
  LOGIN: "Login",
};

// Header Dropdown
export const HEADER_DROPDOWN = {
  DEFAULT_USER: "User",
  ROLE_LABEL: "Role:",
  LOGOUT: "Logout",
};

// Home Page
export const HOME_CONTENT = {
  TITLE: 'Uniting Lords and Ladies. Building Empires.',
  SUBTITLE: 'Your central hub for all GOTC Discord communities, services and news.',
};

// Servers Component
export const SERVERS_CONTENT = {
  TITLE: 'Discord Servers',
  SUBTITLE: 'Explore Discord communities by category',
  BUTTON: 'VIEW ALL CATEGORIES',
};

// Feature Component
export const FEATURE_CONTENT = {
  TITLE: 'FEATURED DISCORD SERVERS',
  BUTTON: 'VIEW ALL',
  JOIN_SERVER: 'JOIN SERVER',
  ONLINE: 'Online',
  MEMBERS: 'Members',
  PLACEHOLDER_IMG: 'IMG',
};

// Services Page
export const SERVICES_CONTENT = {
  TITLE: 'SERVICES PORTAL',
  SUBTITLE: 'Post or find trusted services for Game of Thrones: Conquest',
  DESCRIPTION: 'Explore trusted Game of Thrones: Conquest services, listings and support.',
  BUTTON: 'BROWSE SERVICES',
  POST_BUTTON: 'POST YOUR SERVICE',
};

// Service Card Component
export const SERVICE_CARD = {
  LISTINGS: 'Listings',
  PLACEHOLDER_IMG: 'IMG',
};

// Announcements Component
export const ANNOUNCEMENTS_CONTENT = {
  TITLE: 'ANNOUNCEMENTS',
  BUTTON: 'VIEW ALL',
  EMPTY: 'No Announcements to Show',
};

// Login Modal
export const LOGIN_CONTENT = {
  SIGNIN: {
    TITLE: 'Welcome Back',
    SUBTITLE: 'Log in to access your GOTC account',
    BUTTON: 'Sign In',
  },
  SIGNUP: {
    TITLE: 'Create Account',
    SUBTITLE: 'Join the GOTC community',
    BUTTON: 'Sign Up',
  },
  TOGGLE_SIGNIN: 'Sign In',
  TOGGLE_SIGNUP: 'Sign Up',
  TOGGLE_SIGNIN_Q: "Don't have an account?",
  TOGGLE_SIGNUP_Q: 'Already have an account?',
  FIELDS: {
    USERNAME: 'Username',
    EMAIL: 'Email',
    PASSWORD: 'Password',
    CONFIRM_PASSWORD: 'Confirm Password',
  },
  PLACEHOLDERS: {
    USERNAME: 'Enter username',
    EMAIL: 'Enter email',
    PASSWORD: 'Enter password',
    CONFIRM_PASSWORD: 'Confirm password',
  },
  VALIDATION: {
    USERNAME_REQUIRED: 'Please enter username',
    EMAIL_REQUIRED: 'Please enter email',
    EMAIL_INVALID: 'Enter a valid email',
    PASSWORD_REQUIRED: 'Please enter password',
    CONFIRM_REQUIRED: 'Please confirm password',
    PASSWORDS_MISMATCH: 'The two passwords do not match',
  },
  MESSAGES: {
    LOGIN_SUCCESS: 'Login successful',
    SIGNUP_SUCCESS: 'Signup successful',
    LOGIN_FAILED: 'Login failed',
    SIGNUP_FAILED: 'Signup failed',
    AUTH_FAILED: 'Authentication failed',
  },
};

// About Page
export const ABOUT_CONTENT = {
  TITLE: 'About GOTC Hub',
  DESCRIPTION: 'A central kingdom for Game of Thrones: Conquest communities, trusted services, alliances, announcements, and players.',
  CARDS: [
    {
      TITLE: 'Our Mission',
      DESCRIPTION: 'To unite lords, alliances, and kingdoms in one trusted community hub.',
    },
    {
      TITLE: 'Community First',
      DESCRIPTION: 'Discover Discord servers, connect with players, and grow your empire.',
    },
    {
      TITLE: 'Trusted Services',
      DESCRIPTION: 'Find reliable account services, resources, coaching, and boosting.',
    },
    {
      TITLE: 'Latest Updates',
      DESCRIPTION: 'Stay informed with important announcements, events, and maintenance.',
    },
  ],
};

// Contact Page
export const CONTACT_CONTENT = {
  TITLE: 'Contact The Realm',
  DESCRIPTION: 'Have questions, service requests, partnership ideas, or community concerns? Send your raven.',
  GET_IN_TOUCH: 'Get In Touch',
  HELP_DESCRIPTION: 'Reach out to the GOTC Hub team for support, collaborations, server listings, or service portal related queries.',
  DISCORD: 'Discord Community Support',
  FORM: {
    NAME: 'Name',
    EMAIL: 'Email',
    MESSAGE: 'Message',
    SUBMIT: 'Send Message',
  },
  PLACEHOLDERS: {
    NAME: 'Enter your name',
    EMAIL: 'Enter your email',
    MESSAGE: 'Write your message...',
  },
  VALIDATION: {
    NAME_REQUIRED: 'Please enter your name',
    EMAIL_REQUIRED: 'Please enter your email',
    EMAIL_INVALID: 'Enter a valid email',
    MESSAGE_REQUIRED: 'Please enter your message',
  },
};

// Footer
export const FOOTER_CONTENT = {
  COPYRIGHT: '© 2024 GOTC HUB. All rights reserved.',
  PRIVACY: 'Privacy Policy',
  TERMS: 'Terms of Service',
  CONTACT: 'Contact',
};

// 404 Page
export const PAGE_NOT_FOUND = {
  CODE: '404',
  TITLE: 'PAGE NOT FOUND',
  DESCRIPTION: 'The page you are looking for does not exist or has been moved.',
  BUTTON: 'BACK TO HOME',
};

